import React, { useState } from 'react';
import { CODE_GROUP_ID } from '../constant/Constant';
import CodeUtil from '../util/CodeUtil';
import { viewTime2SaveTime, saveTime2ViewTime } from '../util/TimeTableUtil';
import TimeItemAddButtonBox from './buttons/TimeItemAddButtonBox';
import SelectionBox from './SelectionBox';
import TimeItem from './TimeItem';
import TimePickerBox from './TimePickerBox';
import WeekdayPickerBox from './WeekdayPickerBox';
import NullCheckUtil from '../util/NullCheckUtil';

let MAX_TIMES = 5;

const TimeBox = ({ title = '강의시간', times, edit = false, onChange }) => {
    const [weekdayCd, setWeekdayCd] = useState('MON');
    const [bgnTime, setBgnTime] = useState('0800');
    const [endTime, setEndTime] = useState('0900');
    const [notice, setNotice] = useState(null);

    const handleAdd = () => {
        var time = {
            weekdayCd,
            bgnTime,
            endTime,
        };
        if (Number(bgnTime) >= Number(endTime)) {
            setNotice('종료시간이 시작시간보다 커야 합니다.');
        } else if (times.length < MAX_TIMES) {
            if (NullCheckUtil.isNotEmpty(checkTime(times, time))) {
                setNotice('이미 등록된 시간입니다.');
            } else {
                var array = times.slice();
                array[array.length] = time;
                onChange(array);
                setNotice(null);
            }
        } else {
            setNotice(`강의시간은 최대 ${MAX_TIMES}개 까지 추가할 수 있습니다.`);
        }
    };

    const checkTime = (times, time) => {
        return times.filter((t) => {
            return (
                time.weekdayCd == t.weekdayCd &&
                !(Number(time.endTime) <= Number(t.bgnTime) || Number(time.bgnTime) >= Number(t.endTime))
            );
        });
    };

    const onDelete = (time) => {
        var array = times.slice();
        array = array.filter((a) => a != time);
        onChange(array);
        setNotice(null);
    };

    return (
        <div className='form-box-row box-col'>
            <div className='box-col-tit'>{title}</div>
            {edit ? (
                <div className='form-box-container'>
                    {/* <WeekdayPickerBox size='medium' value={weekdayCd} onChange={(e) => setWeekdayCd(e.target.value)} /> */}
                    <SelectionBox
                        title='요일'
                        w140
                        value={weekdayCd}
                        options={CodeUtil.getCodes(CODE_GROUP_ID.WEEKDAY)}
                        onChange={(e) => setWeekdayCd(e.target.value)}
                        useAll={false}
                    />

                    <TimePickerBox
                        title='시작시간'
                        size='medium'
                        value={bgnTime}
                        onChangeTimeString={(timeString) => setBgnTime(timeString)}
                    />
                    <TimePickerBox
                        title='종료시간'
                        size='medium'
                        value={endTime}
                        onChangeTimeString={(timeString) => setEndTime(timeString)}
                    />
                    <TimeItemAddButtonBox onClick={handleAdd} />
                    <div className='form-box w-md'>
                        {notice && (
                            <div key={5} style={{ color: 'red', fontSize: 13 }}>
                                {notice}
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <></>
            )}
            <div key={20} className={'input-box time-box ' + (edit ? '' : 'disabled')}>
                <div id={title} className='input-group in-box subject-times'>
                    {times &&
                        times.map((time, index) =>
                            edit ? (
                                <React.Fragment key={index}>
                                    <TimeItem time={time} edit onDelete={(time) => onDelete(time)} />
                                </React.Fragment>
                            ) : (
                                <React.Fragment key={index}>
                                    <TimeItem time={time} />
                                </React.Fragment>
                            ),
                        )}
                </div>
            </div>
        </div>
    );
};

export default TimeBox;
